export default "__VITE_ASSET__65183375__"